/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Suspense, lazy} from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import NavBar from './components/Nav';
import './App.css';
import './index.css';
import { useFetchAgentSearch } from '../src/api/searchApi';
import { CgSpinner } from 'react-icons/cg';
const HomePage = lazy(() => import('./containers/HomePage'));
const Reports = lazy(() => import('./containers/Reports'));
const Agent = lazy(() => import('./containers/Agent'));

function App() {

  const { data, isLoading } = useFetchAgentSearch();
  return (
    <Router>
      {isLoading && (
        <div className="h-screen text-blue-500 w-full m-auto flex justify-center items-center bg-gray-700">
          <CgSpinner className="animate-spin h-20 w-20 bg-gray-700" />
        </div>
      )}
      {data && !isLoading ? (
        <>
          <NavBar agents={data.agents} />
          <Suspense
            fallback={
              <div className=" h-screen w-full flex justify-center items-center bg-gray-700">
                <CgSpinner className="animate-spin h-20 w-20 bg-gray-700 text-blue-500" />
              </div>
            }
          >
            <Switch>
              <Route exact path="/">
                <HomePage />
              </Route>
              <Route path="/reports">
                <Reports />
              </Route>
              <Route path="/agent/:id">
                <Agent />
              </Route>
            </Switch>
          </Suspense>
        </>
      ) : null}
    </Router>
  );
}

export default App;
